import type { Event } from "../types/event";
import { appAssets } from "../config/assets";

export const mockEvents: Event[] = [
    {
        id: 1,
        slug: "journee-du-26-avril-thionville",
        title: "Journée Ligue des 2-0 – Dimanche 26 avril à Thionville",
        summary:
            "Quatre rencontres au programme à Thionville : Soudan vs Gambie, Thionville vs Sénégal, Cap-Vert vs Lions et Camerlux vs Hesperange sur le terrain B.",
        description:
            "La Ligue des 2-0 – Luxembourg & 3 Frontières vous donne rendez-vous le dimanche 26 avril au terrain de Thionville pour une nouvelle grande journée de football. Au programme : à 10h00 Soudan face à Gambie, à 12h00 Thionville face à Sénégal, à 14h00 Cap-Vert face à Lions, et à 14h00 également Camerlux face à Hesperange sur le terrain B. Trois belles affiches principales et une belle ambiance sportive en perspective. Venez nombreux soutenir les équipes.",
        image: appAssets.event.event1,
        dateLabel: "Dimanche 26 avril",
        timeLabel: "10h00 - 16h00",
        location: "Terrain de Thionville",
        featured: true,
    },
];